export const ROLE_HEADER = 'Role'
